// extracted by mini-css-extract-plugin
module.exports = {"root":"ChartTooltip_root__VJThr","tooltipItem":"ChartTooltip_tooltipItem__1evur","tooltipLabel":"ChartTooltip_tooltipLabel__GUroY"};